const parks = [
  "Admiral William Standley State Recreation Area",
  "Ahjumawi Lava Springs State Park",
  "Albany State Marine Reserve",
  "Anderson Marsh State Historic Park",
  "Andrew Molera State Park",
  "Angel Island State Park",
  "Año Nuevo State Park",
  "Antelope Valley California Poppy Reserve",
  "Antelope Valley Indian Museum State Historic Park",
  "Anza-Borrego Desert State Park",
  "Armstrong Redwoods State Natural Reserve",
  "Arthur B. Ripley Desert Woodland State Park",
  "Asilomar State Beach",
  "Auburn State Recreation Area",
  "Austin Creek State Recreation Area",
  "Azalea State Natural Reserve",
  "Bale Grist Mill State Historic Park",
  "Bean Hollow State Beach",
  "Benbow State Recreation Area",
  "Benicia Capitol State Historic Park",
  "Benicia State Recreation Area",
  "Bethany Reservoir State Recreation Area",
  "Bidwell Mansion State Historic Park",
  "Bidwell-Sacramento River State Park",
  "Big Basin Redwoods State Park",
  "Bodie State Historic Park",
  "Bolsa Chica State Beach",
  "Border Field State Park",
  "Bothe-Napa Valley State Park",
  "Brannan Island State Recreation Area",
  "Burleigh H. Murray Ranch",
  "Burton Creek State Park",
  "Butano State Park",
  "Butte City Project",
  "Calaveras Big Trees State Park",
  "California Citrus State Historic Park",
  "California Indian Heritage Center State Park",
  "California State Capitol Museum",
  "California State Mining and Mineral Museum",
  "Cambria State Marine Park",
  "Candlestick Point State Recreation Area",
  "Cardiff State Beach",
  "Carlsbad State Beach",
  "Carmel River State Beach",
  "Carnegie State Vehicular Recreation Area",
  "Carpinteria State Beach",
  "Caspar Headlands State Beach",
  "Caspar Headlands State Natural Reserve",
  "Castaic Lake State Recreation Area",
  "Castle Crags State Park",
  "Castle Rock State Park",
  "Caswell Memorial State Park",
  "Cayucos State Beach",
  "China Camp State Park",
  "Chino Hills State Park",
  "Chumash Painted Cave State Historic Park",
  "Clay Pit State Vehicular Recreation Area",
  "Clear Lake State Park",
  "Colonel Allensworth State Historic Park",
  "Columbia State Historic Park",
  "Colusa-Sacramento River State Recreation Area",
  "Corona del Mar State Beach",
  "Crystal Cove State Park",
  "Cuyamaca Rancho State Park",
  "D. L. Bliss State Park",
  "Del Norte Coast Redwoods State Park",
  "Delta Meadows",
  "Dockweiler State Beach",
  "Doheny State Beach",
  "Donner Memorial State Park",
  "Ed Z'berg Sugar Pine Point State Park",
  "El Capitán State Beach",
  "El Presidio de Santa Barbara State Historic Park",
  "Emerald Bay State Park",
  "Emeryville Crescent State Marine Reserve",
  "Emma Wood State Beach",
  "Empire Mine State Historic Park",
  "Estero Bluffs State Park",
  "Folsom Lake State Recreation Area",
  "Folsom Powerhouse State Historic Park",
  "The Forest of Nisene Marks State Park",
  "Fort Humboldt State Historic Park",
  "Fort Ord Dunes State Park",
  "Fort Ross State Historic Park",
  "Fort Tejon State Historic Park",
  "Franks Tract State Recreation Area",
  "Fremont Peak State Park",
  "Garrapata State Park",
  "Gaviota State Park",
  "George J. Hatfield State Recreation Area",
  "Governor's Mansion State Historic Park",
  "Gray Whale Cove State Beach",
  "Great Valley Grasslands State Park",
  "Greenwood State Beach",
  "Grizzly Creek Redwoods State Park",
  "Grover Hot Springs State Park",
  "Half Moon Bay State Beach",
  "Harmony Headlands State Park",
  "Harry A. Merlo State Recreation Area",
  "Hatton Canyon",
  "Hearst San Simeon State Historical Monument",
  "Hearst San Simeon State Park",
  "Heber Dunes State Vehicular Recreation Area",
  "Hendy Woods State Park",
  "Henry Cowell Redwoods State Park",
  "Henry W. Coe State Park",
  "Hollister Hills State Vehicular Recreation Area",
  "Humboldt Lagoons State Park",
  "Humboldt Redwoods State Park",
  "Hungry Valley State Vehicular Recreation Area",
  "Huntington State Beach",
  "Indian Grinding Rock State Historic Park",
  "Indio Hills Palms",
  "Jack London State Historic Park",
  "Jedediah Smith Redwoods State Park",
  "John B. Dewitt Redwoods State Natural Reserve",
  "John Little State Natural Reserve",
  "Jug Handle State Natural Reserve",
  "Julia Pfeiffer Burns State Park",
  "Kenneth Hahn State Recreation Area",
  "Kings Beach State Recreation Area",
  "Kruse Rhododendron State Natural Reserve",
  "La Purísima Mission State Historic Park",
  "Lake Del Valle State Recreation Area",
  "Lake Oroville State Recreation Area",
  "Lake Perris State Recreation Area",
  "Lake Valley State Recreation Area",
  "Leland Stanford Mansion State Historic Park",
  "Leo Carrillo State Park",
  "Leucadia State Beach",
  "Lighthouse Field State Beach",
  "Limekiln State Park",
  "Little River State Beach",
  "Los Angeles State Historic Park",
  "Los Encinos State Historic Park",
  "Los Osos Oaks State Natural Reserve",
  "MacKerricher State Park",
  "Mailliard Woods State Natural Reserve",
  "Malakoff Diggins State Historic Park",
  "Malibu Creek State Park",
  "Malibu Lagoon State Beach",
  "Manchester State Park",
  "Mandalay State Beach",
  "Manresa State Beach",
  "Marconi Conference Center State Historic Park",
  "Marina State Beach",
  "Marsh Creek State Historic Park",
  "Marshall Gold Discovery State Historic Park",
  "Martial Cottle Park State Recreation Area",
  "McArthur-Burney Falls Memorial State Park",
  "McConnell State Recreation Area",
  "McGrath State Beach",
  "McLaughlin Eastshore State Park State Seashore",
  "Mendocino Headlands State Park",
  "Mendocino Woodlands State Park",
  "Millerton Lake State Recreation Area",
  "Mono Lake Tufa State Natural Reserve",
  "Montaña de Oro State Park",
  "Montara State Beach",
  "Monterey State Historic Park",
  "Monterey State Beach",
  "Montgomery Woods State Natural Reserve",
  "Moonlight State Beach",
  "Morro Bay State Park",
  "Morro Strand State Beach",
  "Moss Landing State Beach",
  "Mount Diablo State Park",
  "Mount San Jacinto State Park",
  "Mount Tamalpais State Park",
  "Natural Bridges State Beach",
  "Navarro River Redwoods State Park",
  "New Brighton State Beach",
  "Oceano Dunes State Vehicular Recreation Area",
  "Ocotillo Wells State Vehicular Recreation Area",
  "Old Sacramento State Historic Park",
  "Old Town San Diego State Historic Park",
  "Olompali State Historic Park",
  "Pacheco State Park",
  "Pacifica State Beach",
  "Palomar Mountain State Park",
  "Pelican State Beach",
  "Pescadero State Beach",
  "Petaluma Adobe State Historic Park",
  "Pfeiffer Big Sur State Park",
  "Picacho State Recreation Area",
  "Pigeon Point Light Station State Historic Park",
  "Pío Pico State Historic Park",
  "Pismo State Beach",
  "Placerita Canyon State Park",
  "Plumas-Eureka State Park",
  "Point Cabrillo Light Station State Historic Park",
  "Point Dume State Beach",
  "Point Lobos Ranch",
  "Point Lobos State Natural Reserve",
  "Point Mugu State Park",
  "Point Sal State Beach",
  "Point Sur State Historic Park",
  "Pomponio State Beach",
  "Portola Redwoods State Park",
  "Prairie City State Vehicular Recreation Area",
  "Prairie Creek Redwoods State Park",
  "Providence Mountains State Recreation Area",
  "Railtown 1897 State Historic Park",
  "Rancho San Andrés Castro Adobe",
  "Red Rock Canyon State Park",
  "Refugio State Beach",
  "Reynolds Wayside Campground",
  "Richardson Grove State Park",
  "Rio de Los Angeles State Park State Recreation Area",
  "Robert H. Meyer Memorial State Beach",
  "Robert Louis Stevenson State Park",
  "Robert W. Crown Memorial State Beach",
  "Russian Gulch State Park",
  "Saddleback Butte State Park",
  "Salinas River State Beach",
  "Salt Point State Park",
  "Salton Sea State Recreation Area",
  "Samuel P. Taylor State Park",
  "San Bruno Mountain State Park",
  "San Buenaventura State Beach",
  "San Clemente State Beach",
  "San Elijo State Beach",
  "San Gregorio State Beach",
  "San Juan Bautista State Historic Park",
  "San Luis Reservoir State Recreation Area",
  "San Onofre State Beach",
  "San Pasqual Battlefield State Historic Park",
  "San Timoteo Canyon",
  "Santa Cruz Mission State Historic Park",
  "Santa Monica State Beach",
  "Santa Susana Pass State Historic Park",
  "Schooner Gulch State Beach",
  "Seacliff State Beach",
  "Shasta State Historic Park",
  "Silver Strand State Beach",
  "Silverwood Lake State Recreation Area",
  "Sinkyone Wilderness State Park",
  "Smithe Redwoods State Natural Reserve",
  "Sonoma State Historic Park",
  "Sonoma Coast State Park",
  "South Carlsbad State Beach",
  "South Yuba River State Park",
  "Standish-Hickey State Recreation Area",
  "State Indian Museum",
  "Stone Lake",
  "Sue-meg State Park",
  "Sugarloaf Ridge State Park",
  "Sunset State Beach",
  "Sutter Buttes State Park",
  "Sutter's Fort State Historic Park",
  "Tahoe State Recreation Area",
  "Thornton State Beach",
  "Tijuana Estuary",
  "Tolowa Dunes State Park",
  "Tomales Bay State Park",
  "Tomo-Kahni State Historic Park",
  "Topanga State Park",
  "Torrey Pines State Beach",
  "Torrey Pines State Natural Reserve",
  "Trinidad State Beach",
  "Trione-Annadel State Park",
  "Tule Elk State Natural Reserve",
  "Turlock Lake State Recreation Area",
  "Twin Lakes State Beach",
  "Van Damme State Park",
  "Verdugo Mountains",
  "Ward Creek Project",
  "Washoe Meadows State Park",
  "Wassama Round House State Historic Park",
  "Watts Towers of Simon Rodia State Historic Park",
  "Weaverville Joss House State Historic Park",
  "Westport-Union Landing State Beach",
  "Wilder Ranch State Park",
  "Wildwood Canyon",
  "Will Rogers State Beach",
  "Will Rogers State Historic Park",
  "William B. Ide Adobe State Historic Park",
  "Woodland Opera House State Historic Park",
  "Woodson Bridge State Recreation Area",
  "Zmudowski State Beach",

  "Sequoia & Kings Canyon National Parks",
  "Redwood National & State Parks",
  "Point Reyes National Seashore",
  "Pinnacles National Park",
  "Lassen Volcanic National Park",
  "Joshua Tree National Park",
  "Death Valley National Park",
  "Channel Islands National Park",
  "Yosemite National Park"
]

export default parks
